import React, { useRef, useEffect } from 'react';
import { Backup, DescriptionOutlined } from '@material-ui/icons';
import { useIntl } from 'react-intl';

export function UploadFile({ send, afterClear, setUploading }) {
  const dropRef = useRef(null);
  const footerRef = useRef(null);
  const importRef = useRef(null);
  const fileListRef = useRef(null);
  const { formatMessage } = useIntl();

  useEffect(() => {
    dropRef.current.ondragleave = e => {
      e.preventDefault();
      dropRef.current.classList.remove('active');
    };
    dropRef.current.ondragover = dropRef.current.ondragenter = e => {
      e.preventDefault();
      dropRef.current.classList.add('active');
    };
    dropRef.current.ondrop = e => {
      e.preventDefault();
      dropRef.current.classList.remove('active');
      if (e.dataTransfer.files[1]) return;
      if (e.dataTransfer.files[0].type !== 'application/pdf') return;
      footerRef.current.classList.add('hasFiles');
      onDrop(e.dataTransfer.files);
    };
  });

  async function onDrop(files) {
    if (setUploading) setUploading(true);
    const template = `
            ${Object.keys(files)
              .map(
                file => `
                <div class="file file--${file}">
                    <div class="name">
                        <span>${files[file].name}</span>
                    </div>
                    <div class="progress active" id='${files[file].name}-active'>
                    </div>
                    <div class="done" id='${files[file].name}-done'>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 1000 1000">
                                <g><path id="path" d="M500,10C229.4,10,10,229.4,10,500c0,270.6,219.4,490,490,490c270.6,0,490-219.4,490-490C990,229.4,770.6,10,500,10z M500,967.7C241.7,967.7,32.3,758.3,32.3,500C32.3,241.7,241.7,32.3,500,32.3c258.3,0,467.7,209.4,467.7,467.7C967.7,758.3,758.3,967.7,500,967.7z M748.4,325L448,623.1L301.6,477.9c-4.4-4.3-11.4-4.3-15.8,0c-4.4,4.3-4.4,11.3,0,15.6l151.2,150c0.5,1.3,1.4,2.6,2.5,3.7c4.4,4.3,11.4,4.3,15.8,0l308.9-306.5c4.4-4.3,4.4-11.3,0-15.6C759.8,320.7,752.7,320.7,748.4,325z"</g>
                            </svg>
                        </span>
                    </div>
                </div>`
              )
              .join('')}`;
    dropRef.current.classList.add('hidden');
    footerRef.current.classList.add('hasFiles');
    fileListRef.current.innerHTML = template;
    try {
      await send(files[0]);
      document.getElementById(`${files[0].name}-done`).classList.add('anim');
    } finally {
      if (setUploading) setUploading(false);
      document
        .getElementById(`${files[0].name}-active`)
        .classList.remove('active');
      document.getElementById('divider-upload').classList.add('d-none');
      importRef.current.classList.add('active');
    }
  }

  function clearFiles() {
    document.getElementById('floor-plan-input').value = '';
    fileListRef.current.innerHTML = '';
    footerRef.current.classList.remove('hasFiles');
    importRef.current.classList.remove('active');
    dropRef.current.classList.remove('hidden');
    afterClear();
  }

  return (
    <div className="upload">
      <div className="upload-files">
        <header>
          <p>
            <Backup fontSize="large" className="mr-2" />
            <span className="up">up</span>
            <span className="load">load</span>
          </p>
        </header>
        <div className="body" ref={dropRef}>
          <DescriptionOutlined style={{ color: '#E6E6E6', fontSize: 60 }} />
          <p className="pointer-none mb-0">
            <b>Drag and drop</b> the floor plan here <br /> or{' '}
            <label htmlFor="floor-plan-input">browse</label> to begin the upload
          </p>
          <input
            id="floor-plan-input"
            type="file"
            multiple={false}
            onChange={e => onDrop(e.target.files)}
            accept="application/pdf"
          />
        </div>
        <footer ref={footerRef}>
          <div className="divider-upload" id="divider-upload">
            <span>{formatMessage({ id: 'UPLOADING_MAP' })}</span>
          </div>
          <div className="list-files" ref={fileListRef} />
          <button
            className="import"
            ref={importRef}
            type="button"
            onClick={clearFiles}
          >
            {formatMessage({ id: 'REMOVE_FILE' }).toUpperCase()}
          </button>
        </footer>
      </div>
    </div>
  );
}
